import { gameInstance } from '@Game/GameComponent';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';
import { IActionResponseStep } from '@GFTypes/Responses/ActionResponse';

// Payline in this case is either ways / powerline or winning line
export const getMultiplierForMessage = (
    step: IActionResponseStep,
    isWinline: boolean,
    payLineMultiplier: number | undefined,
    payLineSymbolIds: number[]
): number => {
    const features = gameInstance.gameStore.get(EGameStoreKeys.Features);
    const wallMultiplier = step?.wallMultiplier;

    if (features.wildWheel) {
        return isWinline ? getWildWheelWinlineMultiplier(payLineSymbolIds, step) : payLineMultiplier || 1;
    }

    if (features.wildWheel && !isWinline) {
        return payLineMultiplier || 1;
    }

    if (wallMultiplier) {
        return wallMultiplier;
    }

    return (payLineMultiplier ?? step.winMultiplier) || 1;
};

const getWildWheelWinlineMultiplier = (symbolIds: number[], step: IActionResponseStep): number => {
    const { wild } = gameInstance.gameStore.get(EGameStoreKeys.Features);
    const hasWild = wild && symbolIds.some((id) => wild.includes(id));

    return hasWild && step.winMultiplier ? step.winMultiplier : 1;
};

export const getMultiplierForScatterMessage = (step: IActionResponseStep): number => {
    return step.winMultiplier ?? 1;
};
